<template>
  <Modal :open="open" @close="close">
    <h2 class="text-lg font-semibold mb-4 text-center w-full">Renseigner l'IBAN du client</h2>
    <p class="mb-4">Veuillez saisir l'IBAN du client et joindre le RIB associé.</p>

    <div class="space-y-4">
      <FormField
        id="iban"
        v-model="iban"
        type="text"
        label="IBAN"
        label-class="block text-sm font-medium leading-6 text-gray-900"
        placeholder="FR76 3000 6000 0112 3456 7890 189"
        required
      />

      <FileField
        id="rib-document"
        :form-data="fileFormData"
        label="RIB"
        label-class="font-medium"
        placeholder="Déposez votre RIB"
        required
        @files="onFilesChange"
      />

      <ExtractionStatus
        :extracting="extractingIban"
        :extraction-error="ibanExtractionError"
        :extraction-success="ibanExtractionSuccess"
        :extracting-label="t('iban_extraction_extracting')"
        :error-label="t('iban_extraction_error')"
        :success-label="t('iban_extraction_success')"
        @dismiss-success="ibanExtractionSuccess = false"
      />
    </div>

    <div class="flex justify-center space-x-3 mt-6">
      <SecondaryButton
        @click="handleSubmit"
        :disabled="!isFormValid"
        class="bg-purple-100 hover:bg-purple-200 text-purple-700"
      >
        Valider
      </SecondaryButton>
      <SecondaryButton @click="close">Annuler</SecondaryButton>
    </div>
  </Modal>
</template>

<script>
import { Modal, FormField, FileField, SecondaryButton, ExtractionStatus, extractIbanMixin } from "@estaly/ui";
import { useI18n } from "vue-i18n";
import { mapActions, mapState } from "vuex";

export default {
  components: { FormField, FileField, SecondaryButton, Modal, ExtractionStatus },
  mixins: [extractIbanMixin],
  setup() {
    const { t } = useI18n();
    return { t };
  },
  props: ["open"],
  emits: ["close"],

  data() {
    return {
      iban: "",
      fileFormData: new FormData(),
      hasFile: false,
    };
  },

  computed: {
    ...mapState("claims", ["currentClaim"]),

    isFormValid() {
      return this.iban.trim().length > 0 && this.hasFile;
    },
  },

  methods: {
    ...mapActions("backoffice", ["withLoader"]),
    ...mapActions("iban", ["updateCustomerIban", "extractIban"]),

    onFilesChange() {
      this.hasFile = !!this.fileFormData.get("rib-document");
      this.runIbanExtraction(this.fileFormData.get("rib-document"));
    },

    async handleSubmit() {
      if (!this.isFormValid) return;

      await this.withLoader(async () => {
        const response = await this.updateCustomerIban({
          customerId: this.currentClaim.customer.id,
          iban: this.iban,
          document: this.fileFormData.get("rib-document"),
        });

        if (response?.success) {
          this.close();
        }
      });
    },

    close() {
      this.$emit("close");
      this.iban = "";
      this.fileFormData = new FormData();
      this.hasFile = false;
      this.extractingIban = false;
      this.ibanExtractionError = false;
      this.ibanExtractionSuccess = false;
    },
  },
};
</script>

<i18n src="./IbanUploadModal.i18n.json"></i18n>
